/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Realtime Schema Projection
 * Frontend-only aliases for realtime payload validation.
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {CatalogItemId} from "./catalogItemId.zod";
import {RealtimeResourceChange} from "./realtimeResourceChange.zod";

export const MaterialRealtimeChange = RealtimeResourceChange.and(
  zod.object({
    resource: zod.enum(["engineering.materials"]),
    resourceId: CatalogItemId,
    change: zod.enum(["CREATED", "UPDATED", "DELETED", "RESTORED"]),
  }),
);

export type MaterialRealtimeChange = zod.input<typeof MaterialRealtimeChange>;
export type MaterialRealtimeChangeOutput = zod.output<typeof MaterialRealtimeChange>;
